<ng-container>
  <!--begin::Container-->
  <div class="container-fluid">
    <!--begin::Start Navbar Links-->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-lte-toggle="sidebar" href="#" role="button" (click)="onSidebarCollapseToggle($event)">
          <i class="bi bi-list"></i>
        </a>
      </li>
      <li class="nav-item d-none d-md-block"><a href="#" class="nav-link">Home</a></li>
      <li class="nav-item d-none d-md-block"><a href="#" class="nav-link">Contact</a></li>
      <!--begin::User Profile Badge-->
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="userProfileDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="badge bg-primary d-flex align-items-center">
            <i class="bi bi-shield-check me-1"></i>
            {{ selectedProfile?.profile}} - {{ selectedProfile?.company?.name }}
          </span>
        </a>
        <ul class="dropdown-menu shadow-sm" aria-labelledby="userProfileDropdown" style="min-width: 180px;">
          <li class="dropdown-header text-muted">
            <i class="bi bi-person-gear"></i> Available Profiles
          </li>
          <li><hr class="dropdown-divider"></li>
          <li>
            <div style="max-height: 280px; overflow-y: auto;">
              @for (profile of user?.userProfiles; track profile) {
                <a class="dropdown-item d-flex align-items-center pointer"
                  (click)="selectProfile(profile)"
                  [class.active]="selectedProfile?.userProfileId === profile.userProfileId">
                  @if (selectedProfile?.userProfileId !== profile.userProfileId) {
                    <i class="bi bi-shield-fill me-2"></i>
                  }
                  @if (selectedProfile?.userProfileId === profile.userProfileId) {
                    <i class="bi bi-shield-check me-2"></i>
                  }
                  {{ profile.profile }} - {{ profile.company?.name }}
                </a>
              }
            </div>
          </li>
        </ul>
      </li>
      <!--end::User Profile Badge-->
    </ul>
    <!--end::Start Navbar Links-->

    <!--begin::End Navbar Links-->
    <ul class="navbar-nav ms-auto">
      <!-- Ricerca, messaggi e notifiche non sono ancora collegati: restano visibili
           ma disattivati (header-feature-disabled) finché non vengono sviluppati. -->
      <!--begin::Navbar Search-->
      <li class="nav-item header-feature-disabled" title="Coming soon">
        <a class="nav-link" role="button" aria-disabled="true" tabindex="-1">
          <i class="bi bi-search"></i>
        </a>
      </li>
      <!--end::Navbar Search-->
      <!--begin::Messages Dropdown Menu-->
      <li class="nav-item dropdown header-feature-disabled" title="Coming soon">
        <a class="nav-link" role="button" aria-disabled="true" tabindex="-1">
          <i class="bi bi-chat-text"></i>
          <span class="navbar-badge badge text-bg-danger">3</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
          <a href="#" class="dropdown-item">
            <!--begin::Message-->
            <div class="d-flex">
              <div class="flex-shrink-0">
                <img src="/assets/images/user1-128x128.jpg" alt="User Avatar"
                  class="img-size-50 rounded-circle me-3" />
              </div>
              <div class="flex-grow-1">
                <h3 class="dropdown-item-title">
                  Brad Diesel
                  <span class="float-end fs-7 text-danger"><i class="bi bi-star-fill"></i></span>
                </h3>
                <p class="fs-7">Call me whenever you can...</p>
                <p class="fs-7 text-secondary">
                  <i class="bi bi-clock-fill me-1"></i> 4 Hours Ago
                </p>
              </div>
            </div>
            <!--end::Message-->
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <!--begin::Message-->
            <div class="d-flex">
              <div class="flex-shrink-0">
                <img src="/assets/images/user8-128x128.jpg" alt="User Avatar"
                  class="img-size-50 rounded-circle me-3" />
              </div>
              <div class="flex-grow-1">
                <h3 class="dropdown-item-title">
                  John Pierce
                  <span class="float-end fs-7 text-secondary">
                    <i class="bi bi-star-fill"></i>
                  </span>
                </h3>
                <p class="fs-7">I got your message bro</p>
                <p class="fs-7 text-secondary">
                  <i class="bi bi-clock-fill me-1"></i> 4 Hours Ago
                </p>
              </div>
            </div>
            <!--end::Message-->
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <!--begin::Message-->
            <div class="d-flex">
              <div class="flex-shrink-0">
                <img src="/assets/images/user3-128x128.jpg" alt="User Avatar"
                  class="img-size-50 rounded-circle me-3" />
              </div>
              <div class="flex-grow-1">
                <h3 class="dropdown-item-title">
                  Nora Silvester
                  <span class="float-end fs-7 text-warning">
                    <i class="bi bi-star-fill"></i>
                  </span>
                </h3>
                <p class="fs-7">The subject goes here</p>
                <p class="fs-7 text-secondary">
                  <i class="bi bi-clock-fill me-1"></i> 4 Hours Ago
                </p>
              </div>
            </div>
            <!--end::Message-->
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>
        </div>
      </li>
      <!--end::Messages Dropdown Menu-->
      <!--begin::Notifications Dropdown Menu-->
      <li class="nav-item dropdown header-feature-disabled" title="Coming soon">
        <a class="nav-link" role="button" aria-disabled="true" tabindex="-1">
          <i class="bi bi-bell-fill"></i>
          <span class="navbar-badge badge text-bg-warning">15</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="bi bi-envelope me-2"></i> 4 new messages
            <span class="float-end text-secondary fs-7">3 mins</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="bi bi-people-fill me-2"></i> 8 friend requests
            <span class="float-end text-secondary fs-7">12 hours</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="bi bi-file-earmark-fill me-2"></i> 3 new reports
            <span class="float-end text-secondary fs-7">2 days</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer"> See All Notifications </a>
        </div>
      </li>
      <!--end::Notifications Dropdown Menu-->
      <!--begin::Return To Admin-->
      @if (impersonation) {
        <li class="nav-item">
          <a class="nav-link pointer" (click)="returnToAdmin()" title="Return to your account">
            <span class="badge bg-warning text-dark d-flex align-items-center">
              <i class="bi bi-arrow-return-left me-1"></i>
              Return to {{ impersonation.firstName }} {{ impersonation.lastName }}
            </span>
          </a>
        </li>
      }
      <!--end::Return To Admin-->
      <!--begin::Fullscreen Toggle-->
      <li class="nav-item">
        <a class="nav-link" href="#" data-lte-toggle="fullscreen">
          <i data-lte-icon="maximize" class="bi bi-arrows-fullscreen"></i>
          <i data-lte-icon="minimize" class="bi bi-fullscreen-exit" style="display: none"></i>
        </a>
      </li>
      <!--end::Fullscreen Toggle-->
      <!--begin::User Menu Dropdown-->
      <li class="nav-item dropdown user-menu">
        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
          <img *ngIf="logoUrl" [src]="logoUrl" class="user-image rounded-circle shadow object-fit-contain"
            alt="User Image" />
          <span class="d-none d-md-inline">{{ user?.firstName }} {{ user?.lastName }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
          <!--begin::User Image-->
          <li class="user-header text-bg-primary">
            <img *ngIf="logoUrl" [src]="logoUrl" class="rounded-circle shadow object-fit-contain"
              alt="User Image" />
            <p>
              <span>
                {{ user?.firstName }} {{ user?.lastName }}
              </span>
              <small>Member since {{user?.createTime | date}}</small>
            </p>
          </li>
          <!--end::User Image-->
          <!--begin::Menu Body-->
          <!-- <li class="user-body"> -->
          <!--begin::Row-->
          <!-- <div class="row">
          <div class="col-4 text-center"><a href="#">Followers</a></div>
          <div class="col-4 text-center"><a href="#">Sales</a></div>
          <div class="col-4 text-center"><a href="#">Friends</a></div>
        </div> -->
        <!--end::Row-->
      <!-- </li> -->
      <!--end::Menu Body-->
      <!--begin::Menu Footer-->
      <li class="user-footer">
        <a (click)="goToProfile()" class="btn btn-default btn-flat pointer">Profile</a>
        <a (click)="SignOut()" class="btn btn-default btn-flat float-end">Sign out</a>
      </li>
      <!--end::Menu Footer-->
    </ul>
  </li>
  <!--end::User Menu Dropdown-->
</ul>
<!--end::End Navbar Links-->
</div>
<!--end::Container-->
</ng-container>